import { createSlice } from "@reduxjs/toolkit";

const initialState ={
    modalShow : false,
    apercuShow : false,
    ajoutsuccess : false,
    listVendeurs : [],
    listCamions : [],
    list : [],
    ajoutOk : false,
}

const Boncommandes = createSlice({
    name : 'BoncommandesData',
    initialState,
    reducers :{
        showmodal:(state,action) =>{
            state.modalShow=action.payload
        },
        ajoutsuccess:(state,action) =>{
            state.ajoutsuccess=action.payload
        },
        getList:(state,action) =>{
            state.list=action.payload
        },
        showapercu:(state,action) =>{
            state.apercuShow=action.payload
        },
        getvendeurs:(state,action) =>{
            state.listVendeurs=action.payload
        },
        getcamions:(state,action) =>{
            state.listCamions=action.payload
        },
        ajout:(state,action) =>{
            state.ajoutOk=action.payload
    },
    addOne:(state,action) =>{
        state.list.push(action.payload)
},
remove: (state, action) => {    
    const id = action.payload;
    state.list=state.list.filter(element => element._id !== id);
  }
    }
})

export const {showmodal,getList,ajout,ajoutsuccess,showapercu,getvendeurs,getcamions,addOne,remove} = Boncommandes.actions
export default Boncommandes.reducer;